import React, {Component, useState} from "react";
import {Table, Input, Button, Label, DropdownMenu, DropdownItem, ButtonDropdown, DropdownToggle} from "reactstrap";
import { globals } from "../Globals/Globals";
import {useSelector, useDispatch } from 'react-redux';
import {deleteEvent, reassignEvent} from "../../redux/eventSlice";
import {openModalEvent} from "../../redux/modalSlice";
import EventCard from "../EventCard/EventCard";

const EventsRawTable = (props) => {  
    const dispatch = useDispatch();
    const {reassign_result} = useSelector((state) => state.events)

    React.useEffect(() => {
        // eslint-disable-next-line no-unused-vars
        let isMounted = true

        if (reassign_result.status === 'reassigned'){
            if (globals.parameters.redux_debugging) alert("event successfully reassigned")
        }
        // Cleanup function
        return () => {
            isMounted = false;
        }
    }, [reassign_result, dispatch]);
    
    /**
     * 
     * @param {*} this 
     * @param {*} handleManager 
     * @param {*} eventItem 
     * @param {*} data_guid 
     */
    const handleManager = async (p_s_item_key, p_callback_handler) => {
        try {
            if (globals.parameters.debugging) console.log("handleManager::p_s_item_key =>", p_s_item_key)
                p_callback_handler(props.event_list.find((item) => item.data_guid == p_s_item_key))
        } catch (error) {
            alert(`handleManager for ${p_callback_handler} raise error ${error.message}`)
        }
    }

    /**
     * ReadWriteEventTableRendering
     * @description Render the table with read and write mode
     * @returns {JSX.Element}
     */
    const ReadWriteEventTableRendering = () => {
        let table_body = null;

        if (!((props.event_list != null) && (props.event_list.length > 0))){
            table_body = <tr><td colSpan="4">Aucun évènement</td></tr>;
        }
        else{
            table_body = props.event_list.map((eventItem,i)=>{
                let l_boolEventsIsEnabled = (eventItem.data_blob.data_tier.validation && eventItem.data_blob.data_tier.validation == "Oui");

                return  <tr key={eventItem.data_guid} className="thumbnail">
                            <td className="col_desc"><p>{eventItem.data_blob.data_tier.day}/{eventItem.data_blob.data_tier.month}/{eventItem.data_blob.data_tier.year}</p></td>  
                            <td className="col_desc"><p>{eventItem.data_blob.data_tier.hour}:{eventItem.data_blob.data_tier.minutes}</p></td>  
                            <td className="col_desc"><p>{eventItem.data_blob.data_tier.title}</p></td>
                            <td className="col_desc"><p>{eventItem.data_blob.data_tier.text}</p></td>
                            <td className="col_desc"><p>{eventItem.data_blob.data_tier.media_filename}</p></td>  
                            <td id="table-item-container">
                                <div id="table-item">
                                        <p>{eventItem.title}</p>
                                </div>
                                <div id="table-commands">
                                    {(!props.read_only && !l_boolEventsIsEnabled)&&
                                        <div className="col_logo">
                                            <Button className="get-in-button" 
                                                onClick={()=>{handleManager(eventItem.data_guid, (eventObject)=>{if (window.confirm(`Valider l'évènement ${eventObject.data_blob.data_tier.title} ?`)) dispatch(reassignEvent({event_data_guid:eventObject, event_action:"valider"}))})}} 
                                                style={{cursor:"pointer"}}>Valider</Button>
                                        </div>}
                                    {false && (!props.read_only && l_boolEventsIsEnabled)&&
                                        <div className="col_logo">
                                            <Button className="get-in-button" 
                                                onClick={()=>{handleManager(eventItem.data_guid, (eventObject)=>{if (window.confirm(`Désactiver l'évènement ${eventObject.data_blob.data_tier.title} ?`)) dispatch(reassignEvent({event_data_guid:eventObject, event_action:"desactiver"}))})}} 
                                                style={{cursor:"pointer"}}>Valider</Button>
                                        </div>}

                                    {!props.read_only &&
                                        <div className="col_logo">
                                            <Button onClick={()=>{handleManager(eventItem.data_guid, (eventObject)=>{if (window.confirm(`Supprimer l'évènement' ${eventObject.data_blob.data_tier.title} ?`)) dispatch(deleteEvent(eventObject))})}} 
                                            style={{cursor:"pointer"}}>Effacer</Button>
                                        </div>}
                                    
                                    {!props.read_only &&
                                        <div className="col_logo">
                                            <Button onClick={()=>{handleManager(eventItem.data_guid, (eventObject)=>{dispatch(openModalEvent({event_data_guid:eventObject, read_only:false}))})}} 
                                            style={{cursor:"pointer"}}>Modifier</Button>
                                        </div>}
                                </div>
                            </td>
                        </tr>});}

        return(
            <Table striped responsive={true}>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Heure</th>
                        <th>Titre</th>
                        <th>Description</th>
                        <th>Media none/audio/video</th>
                    </tr>
                </thead>
                <tbody>
                    {table_body}
                </tbody>
            </Table>
            );
    }

    /**
     * ReadOnlyEventTableRendering
     * @description Render the table with read only mode
     * @returns {JSX.Element}
     * @memberof EventsRawTable
     */
    const ReadOnlyEventTableRendering = () => {
        let table_body = null;

        if (!((props.event_list != null) && (props.event_list.length > 0))){
            table_body = <div>Aucun évènement</div>;
        }
        else{
            table_body = props.event_list.map((eventItem,i)=>{
                return  <tr key={eventItem.data_guid} className="thumbnail">
                        <td className="col_desc"><p>{eventItem.data_blob.data_tier.day}/{eventItem.data_blob.data_tier.month}/{eventItem.data_blob.data_tier.year}</p></td>  
                        <td className="col_desc"><p>{eventItem.data_blob.data_tier.title}</p></td>
                        <td className="col_desc"><p>{eventItem.data_blob.data_tier.text}</p></td>  
                    </tr>});
                }

        return(
            <Table striped responsive={true}>
                <thead>
                    <tr>
                        <th>Date</th>
                        <th>Titre</th>
                        <th>Description</th>
                    </tr>
                </thead>
                <tbody>
                    {table_body}
                </tbody>
            </Table>
            );
    }

    /***
     * EventGridRendering
     */
    const EventGridRendering = () => {
        let events_card_grid = null;
        if (!((props.event_list != null) && (props.event_list.length > 0))){
            events_card_grid = <div>Aucun évènement</div>;
        }
        else{
            events_card_grid = props.event_list.map((eventItem,i)=>{
                return  <EventCard 
                            key={eventItem.data_guid}
                            data={eventItem.data_blob.data_tier}
                            onClick={() => {console.log("EventsGrid::OnClick => EventItem", eventItem);if (props.onEventClickHandler) props.onEventClickHandler(eventItem)}}/>});
        }

        return(
            <>
                {props.subtitle}
                <div className="partners-columns-container">
                    {events_card_grid}
                </div>
            </>
            );
    }

    return (
        <>
            {/* Master list of available Events */}
            {(props.grid) && EventGridRendering()}
            {(!props.grid) && ((props.read_only)?ReadOnlyEventTableRendering():ReadWriteEventTableRendering())}
        </>);
}

export default EventsRawTable;
